import { createRouter, createWebHistory } from 'vue-router'
import useUserStore from '@/stores/user';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/DashboardView/DashboardView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      meta: { requiresAuth: false, transition: 'slide-right' }
    },
    // {
    //   path: '/users/edit/:id',
    //   name: 'edit-user',
    //   component: () => import('../views/MediaEditorView/MediaEditorView.vue'),
    //   meta: { requiresAuth: true }
    // },
    
    // Lists pages
    {
      path: '/media',
      name: 'media',
      component: () => import('../views/MediaListView/MediaListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/playlists',
      name: 'playlists',
      component: () => import('../views/PlaylistsListView/PlaylistsListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: () => import('../views/CampaignsListView/CampaignsListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/players',
      name: 'players',
      component: () => import('../views/PlayersListView/PlayersListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/player-subscriptions',
      name: 'player-subscriptions',
      component: () => import('../views/PlayerSubscriptionsListView/PlayerSubscriptionsListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/live-streams',
      name: 'live-streams',
      component: () => import('../views/LiveStreamsListView/LiveStreamsListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('../views/AnalyticsView/AnalyticsView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('../views/ReportsView/ReportsView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/pos-sources',
      name: 'pos-sources',
      component: () => import('../views/POSSourcesListView/POSSourcesListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/organizations',
      name: 'organizations',
      component: () => import('../views/SettingsViews/OrganizationsListView/OrganizationsListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import('../views/SettingsViews/LocationsListView/LocationsListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('../views/SettingsViews/UsersListView/UsersListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/users/create',
      name: 'users-create',
      component: () => import('../views/SettingsViews/UsersListView/CreateUserForm/CreateUserForm.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    
    {
      path: '/roles',
      name: 'roles',
      component: () => import('../views/SettingsViews/RolesListView/RolesListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/roles/create',
      name: 'roles-create',
      component: () => import('../views/SettingsViews/RolesListView/CreateRoleForm/CreateRoleForm.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/auditing',
      name: 'auditing',
      component: () => import('../views/SettingsViews/AuditingListView/AuditingListView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },

    // Editors pages
    {
      path: '/media/edit/:id',
      name: 'media-editor',
      component: () => import('../views/MediaEditorView/MediaEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/playlists/edit/:id',
      name: 'playlist-editor',
      component: () => import('../views/PlaylistEditorView/PlaylistEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/campaigns/edit/:id',
      name: 'campaign-editor',
      component: () => import('../views/CampaignEditorView/CampaignEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/players/edit/:id',
      name: 'player-editor',
      component: () => import('../views/PlayerEditorView/PlayerEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/pos-sources/edit/:id',
      name: 'pos-source-editor',
      component: () => import('../views/POSSourceEditorView/POSSourceEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/player-subscriptions/edit/:id',
      name: 'player-subscription-editor',
      component: () => import('../views/PlayerSubscriptionEditorView/PlayerSubscriptionEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/live-streams/edit/:id',
      name: 'live-stream-editor',
      component: () => import('../views/LiveStreamEditorView/LiveStreamEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/organizations/edit/:id',
      name: 'organization-editor',
      component: () => import('../views/SettingsViews/OrganizationEditorView/OrganizationEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/locations/edit/:id',
      name: 'location-editor',
      component: () => import('../views/SettingsViews/LocationEditorView/LocationEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/users/edit/:id',
      name: 'user-editor',
      component: () => import('../views/SettingsViews/UsersEditorView/UserEditorForm.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/roles/edit/:id',
      name: 'role-editor',
      component: () => import('../views/SettingsViews/RoleEditorView/RoleEditorView.vue'),
      // TODO: think about making a generic component "SimpleEntityEditor" that will be used for all simple entities — N2MErZC3
      meta: { requiresAuth: true }
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('../views/AccountEditorView/AccountEditorView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: "/Account/ChangePassword",
      name: "reset-password",
      component: () => import('../views/ResetPasswordView/ResetPasswordView.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/knowledge-base',
      name: 'knowledge-base',
      component: () => import('../views/KnowledgeBaseView/KnowledgeBaseView.vue'),
      meta: { requiresAuth: true, transition: 'slide-right' }
    },
    {
      path: '/knowledge-base/article/:id',
      name: 'knowledge-base-article',
      component: () => import('../views/KnowledgeBaseView/KnowledgeBaseArticleView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/bulkregistration/:deviceUuid',
      name: 'bulk-registration',
      component: () => import('../views/BulkRegistrationView/BulkRegistrationView.vue'),
      meta: {
        requiresAuth: false,
        standalone: true
      }
    },
  ]
})

router.beforeEach((to) => {
  const user = useUserStore()
  // Restore session from localStorage before auth decisions so deep links
  // and refreshes don't race ahead of onMounted-based checkLogin().
  user.checkLogin()

  if (!to.meta.requiresAuth) return

  if (!user.isLoggedIn) {
    return {
      name: 'login',
      query: { redirect: to.fullPath }
    }
  }
})

export default router
